import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createUnknownComponentVNode as _$cc, noop as _$no, createElementVNode as _$ce, className as _$cn, createTextVNode as _$ct, createVNode as _$cv } from 'intact-vue-next';
import { linkEvent } from 'intact-vue-next';
import { getRestProps } from '../utils';
import { makeStyles } from './styles';
import { Icon } from '../icon';
var _$tmp0 = {
  'className': 'ion-android-star'
};
export default function ($props, $blocks, $__proto__) {
  var _classNameObj;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    className = _this$get.className,
    count = _this$get.count,
    disabled = _this$get.disabled,
    half = _this$get.half;
  var _this$activeValue = this.activeValue,
    activeValue = _this$activeValue.activeValue,
    onClick = _this$activeValue.onClick,
    onMouseEnter = _this$activeValue.onMouseEnter,
    onMouseLeaveComponent = _this$activeValue.onMouseLeaveComponent;
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-rate"] = true, _classNameObj[k + "-disabled"] = disabled, _classNameObj[className] = className, _classNameObj[makeStyles(k)] = true, _classNameObj);
  var icon = (_$blocks['icon'] = function ($super) {
    return _$cc(Icon, _$tmp0);
  }, __$blocks['icon'] = function ($super, data) {
    var block = $blocks['icon'];
    var callBlock = function callBlock() {
      return _$blocks['icon'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['icon'](_$no));
  var rateIcon = function rateIcon(className, step) {
    return _$ce(2, 'div', icon, 0, _$cn(className), {
      'ev-click': linkEvent(step, onClick),
      'ev-mouseenter': linkEvent(step, onMouseEnter)
    });
  };
  var items = [];
  for (var i = 0; i < count; i++) {
    var _$cn2;
    var _className = activeValue.value >= i + 1 ? [k + "-full"] : activeValue.value === i + 0.5 ? [k + "-half"] : null;
    var halfStep = half ? i + 0.5 : i + 1;
    var item = _$ce(2, 'div', [rateIcon(k + "-rate-first", halfStep), _$ct('\n            '), rateIcon(k + "-rate-second", i + 1)], 0, _$cn((_$cn2 = {}, _$cn2[k + "-rate-item"] = true, _$cn2[_className] = _className, _$cn2)));
    items.push(item);
  }
  return _$cv('div', _extends({}, getRestProps(this), {
    'className': _$cn(classNameObj),
    'ev-mouseleave': onMouseLeaveComponent
  }), items);
}
;